<div class='editor-sidebar-text mb-2'>
    <label [innerHTML]='title'></label>
    <div class="entity-list">
      <div class="entity-list-item" (click)="openDetails(item)" *ngFor="let item of entities">
        <pt-entity-icon [entity]='entity' [width]='25' style="margin-right: 7px"></pt-entity-icon>
        <div class="details-link">{{ item.name }}</div>
      </div>
    </div>
</div>
